import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// fancyapps
import { Fancybox } from "@fancyapps/ui";

function gallerySection() {
    const thumbnailImages = document.querySelectorAll('.gallery__thumbnail-image-container');
    thumbnailImages.forEach((item) => {
        item.addEventListener('click', (e) => {
            if(window.innerWidth < 992) {
                gsap.to(window, { duration: 0.1, scrollTo: { y: `#theme-breadcrumb` } });
            }

            // add class active
            thumbnailImages.forEach(i => {
                i.classList.remove('active');
            })
            item.classList.add('active');

            let galleryID = item.getAttribute('data-id');
            
            // get element target
            let previewImage = document.querySelector('.gallery__image');
            let previewImageDate = document.querySelector('.gallery__date');
            let previewImageTitle = document.querySelector('.gallery__image-title');

            // get portfolio value
            let image = galleryJson[galleryID].image;
            let date = galleryJson[galleryID].date;
            let title = galleryJson[galleryID].title;

            // add value to element target
            previewImage.src = image ? image : null;
            previewImageDate.innerHTML = date ? date : '-';
            previewImageTitle.innerHTML = title ? title : '-';

            
        })
    })

    const introDescription = document.querySelector(".gallery .theme-row");
    const introImage = document.querySelector(".gallery__preview");
    let mm = gsap.matchMedia()
    mm.add("(min-width: 992px)", () => {
        ScrollTrigger.create({
            trigger: introDescription,
            pin: introImage,
            start: "top-=11% top",
            end: "bottom-=31% center",
            // markers: true
        });
    })

    Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        Toolbar: {
            display: {
                // left: [],
                // middle: [],
                right: ["close"],
            },
        },
        Images : {
        	zoom : false
        },
        backdropClick: false
    });
}

function loadMore() {
    var loadMoreButton = document.querySelector('.theme-button--load-more');
    var galleryImages = document.querySelectorAll('.other-gallery__image-col.hidden');
    var imagesPerPage = 12;
    var currentIndex = 0;

    loadMoreButton.addEventListener('click', function() {
        loadMoreButton.classList.add('loading');
        
        setTimeout(() => {
            for (var i = currentIndex; i < currentIndex + imagesPerPage && i < galleryImages.length; i++) {
                galleryImages[i].classList.remove('hidden');
            }
            currentIndex += imagesPerPage;

            if (currentIndex >= galleryImages.length) {
                loadMoreButton.style.display = 'none';
            } else {
                loadMoreButton.classList.remove('loading');
            }
        }, 1000)
    });
}

document.addEventListener('DOMContentLoaded', () => {
    gallerySection();
    loadMore();
})

window.addEventListener('resize', () => {
})